// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__YZX8z","mainC":"NotFound_mainC__rMf-s","message":"NotFound_message__KTtrf","footer":"NotFound_footer__164jF","legal":"NotFound_legal__B81hW"};